// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickProtocolScreen__spImg___LYwMd {
    width: 10vw;
    height: 10vw;
    border-radius: 100vw;
    align-self: center;
}


.StickProtocolScreen__slogan___fnzdW {
    align-self: center;
    padding-top: 1vh;
    color: #363636;
    text-align: center;
}

.StickProtocolScreen__omar___Q6BLA {
    align-self: center;
    margin-top: 2vh;
    color: #363636;
    text-decoration: none;
}

.StickProtocolScreen__omar___Q6BLA:hover {
    color: #6060FF;
}

.StickProtocolScreen__title___PrEl5 {
    padding-top: 2vh;
    align-self: center;
    color: #363636;
}

.StickProtocolScreen__h1___azSCW {
    padding-top: 2vh;
    color: #363636;
}

.StickProtocolScreen__h2___pLoXh {
    padding-top: 2vh;
    color: #363636;
}

.StickProtocolScreen__h3___cxVCg {
    padding-top: 2vh;
    color: #363636;
}

.StickProtocolScreen__q___ZMhtQ {
    padding-top: 3vh;
    color: #363636;
}


.StickProtocolScreen__p___xX3PZ {
    padding-top: 2vh;
    line-height: 1.5;
    color: #363636;
}

.StickProtocolScreen__description___AdD3_ {
    /*color: grey;*/
    padding-top: 5vh;
    color: #363636;
}


.StickProtocolScreen__ans___CvsJr {
    padding-top: 1.5vh;
    line-height: 1.5;
    color: #363636;
}

.StickProtocolScreen__a___UCtoJ {
    color: #363636;
}


.StickProtocolScreen__ul___iMGbd, .StickProtocolScreen__ol___Ba2Xj {
    padding-top: 1vh;
    padding-left: 2vw;
}

.StickProtocolScreen__li___nvkwL {
    padding-bottom: 1vh;
    line-height: 1.5;
    color: #363636;
}

.StickProtocolScreen__flowDiagram___LY1Lo {
    width: 100%;
    padding-top: 2vh;
}

.StickProtocolScreen__figcaption___CO1p0 {
    text-align: center;
    padding-top: 2vh;
    color: #363636;
}

.StickProtocolScreen__ticksContainer___Uu_tj {
    padding-top: 1vh;
    padding-left: 1vw;
}

.StickProtocolScreen__ticksContainer___Uu_tj > p {
    padding-top: 1vh;
    color: #363636;
}

.StickProtocolScreen__link___JAsXZ, .StickProtocolScreen__menuItem___CopS4 {
    text-decoration: none;
    color: #6060FF;
}

.StickProtocolScreen__link___JAsXZ:hover, .StickProtocolScreen__menuItem___CopS4:hover {
    text-decoration: underline;
}

.StickProtocolScreen__linkBullet___VlJVe {
    color: var(--black);
    text-decoration: none;
}


.StickProtocolScreen__hLine___cyMv4 {
    margin-top: 3vh;
    border-top: 1px solid lightgray;
}

@media screen and (max-width: 1100px) {
    .StickProtocolScreen__spImg___LYwMd {
        width: 50vw;
        height: 50vw;
    }

    .StickProtocolScreen__ul___iMGbd, .StickProtocolScreen__ol___Ba2Xj {
        padding-left: 10vw;
    }

    .StickProtocolScreen__flowDiagram___LY1Lo {
        width: 100vw;
        transform: translateX(-5vw);
    }
}

/* Usage docs */

.StickProtocolScreen__code___WcH_s {
    margin-top: 2vh;
    padding: 1vw;
}

@media screen and (min-width: 1100px) {
    .StickProtocolScreen__bodyBorder___Wk5la {
        border-left: 1px solid lightgrey;
    }

    .StickProtocolScreen__contents___c0J4q {
        position: fixed;
        left: 3vw;
    }

    .StickProtocolScreen__menuItem___CopS4 {
        text-decoration: none;
        color: var(--black);
    }

    .StickProtocolScreen__menuItem___CopS4:hover {
        color: #6060FF;
    }
}
`, "",{"version":3,"sources":["webpack://./src/website/css/StickProtocolScreen.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;;AAGA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;AACJ;;AAEA,eAAe;;AAEf;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".spImg {\n    width: 10vw;\n    height: 10vw;\n    border-radius: 100vw;\n    align-self: center;\n}\n\n\n.slogan {\n    align-self: center;\n    padding-top: 1vh;\n    color: #363636;\n    text-align: center;\n}\n\n.omar {\n    align-self: center;\n    margin-top: 2vh;\n    color: #363636;\n    text-decoration: none;\n}\n\n.omar:hover {\n    color: #6060FF;\n}\n\n.title {\n    padding-top: 2vh;\n    align-self: center;\n    color: #363636;\n}\n\n.h1 {\n    padding-top: 2vh;\n    color: #363636;\n}\n\n.h2 {\n    padding-top: 2vh;\n    color: #363636;\n}\n\n.h3 {\n    padding-top: 2vh;\n    color: #363636;\n}\n\n.q {\n    padding-top: 3vh;\n    color: #363636;\n}\n\n\n.p {\n    padding-top: 2vh;\n    line-height: 1.5;\n    color: #363636;\n}\n\n.description {\n    /*color: grey;*/\n    padding-top: 5vh;\n    color: #363636;\n}\n\n\n.ans {\n    padding-top: 1.5vh;\n    line-height: 1.5;\n    color: #363636;\n}\n\n.a {\n    color: #363636;\n}\n\n\n.ul, .ol {\n    padding-top: 1vh;\n    padding-left: 2vw;\n}\n\n.li {\n    padding-bottom: 1vh;\n    line-height: 1.5;\n    color: #363636;\n}\n\n.flowDiagram {\n    width: 100%;\n    padding-top: 2vh;\n}\n\n.figcaption {\n    text-align: center;\n    padding-top: 2vh;\n    color: #363636;\n}\n\n.ticksContainer {\n    padding-top: 1vh;\n    padding-left: 1vw;\n}\n\n.ticksContainer > p {\n    padding-top: 1vh;\n    color: #363636;\n}\n\n.link, .menuItem {\n    text-decoration: none;\n    color: #6060FF;\n}\n\n.link:hover, .menuItem:hover {\n    text-decoration: underline;\n}\n\n.linkBullet {\n    color: var(--black);\n    text-decoration: none;\n}\n\n\n.hLine {\n    margin-top: 3vh;\n    border-top: 1px solid lightgray;\n}\n\n@media screen and (max-width: 1100px) {\n    .spImg {\n        width: 50vw;\n        height: 50vw;\n    }\n\n    .ul, .ol {\n        padding-left: 10vw;\n    }\n\n    .flowDiagram {\n        width: 100vw;\n        transform: translateX(-5vw);\n    }\n}\n\n/* Usage docs */\n\n.code {\n    margin-top: 2vh;\n    padding: 1vw;\n}\n\n@media screen and (min-width: 1100px) {\n    .bodyBorder {\n        border-left: 1px solid lightgrey;\n    }\n\n    .contents {\n        position: fixed;\n        left: 3vw;\n    }\n\n    .menuItem {\n        text-decoration: none;\n        color: var(--black);\n    }\n\n    .menuItem:hover {\n        color: #6060FF;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spImg": `StickProtocolScreen__spImg___LYwMd`,
	"slogan": `StickProtocolScreen__slogan___fnzdW`,
	"omar": `StickProtocolScreen__omar___Q6BLA`,
	"title": `StickProtocolScreen__title___PrEl5`,
	"h1": `StickProtocolScreen__h1___azSCW`,
	"h2": `StickProtocolScreen__h2___pLoXh`,
	"h3": `StickProtocolScreen__h3___cxVCg`,
	"q": `StickProtocolScreen__q___ZMhtQ`,
	"p": `StickProtocolScreen__p___xX3PZ`,
	"description": `StickProtocolScreen__description___AdD3_`,
	"ans": `StickProtocolScreen__ans___CvsJr`,
	"a": `StickProtocolScreen__a___UCtoJ`,
	"ul": `StickProtocolScreen__ul___iMGbd`,
	"ol": `StickProtocolScreen__ol___Ba2Xj`,
	"li": `StickProtocolScreen__li___nvkwL`,
	"flowDiagram": `StickProtocolScreen__flowDiagram___LY1Lo`,
	"figcaption": `StickProtocolScreen__figcaption___CO1p0`,
	"ticksContainer": `StickProtocolScreen__ticksContainer___Uu_tj`,
	"link": `StickProtocolScreen__link___JAsXZ`,
	"menuItem": `StickProtocolScreen__menuItem___CopS4`,
	"linkBullet": `StickProtocolScreen__linkBullet___VlJVe`,
	"hLine": `StickProtocolScreen__hLine___cyMv4`,
	"code": `StickProtocolScreen__code___WcH_s`,
	"bodyBorder": `StickProtocolScreen__bodyBorder___Wk5la`,
	"contents": `StickProtocolScreen__contents___c0J4q`
};
export default ___CSS_LOADER_EXPORT___;
